export const API_HOST =
  process.env.REACT_APP_API_HOST || "http://localhost:8000/api";

export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
